import axios from "./general/HttpClient";
import { FormField, TextInput, Text, Image, Box, Button, Stack } from "grommet";
import React from "react";
import { Theme } from "./ThemeStore";
import StyledModal from "./components/StyledModel";

let eventSource;

const ThemeViewOld = ({ theme, onUpdate }: { theme: Theme; onUpdate: Function }) => {
    const [name, setName] = React.useState(theme.name);

    const update = async () => {
        await axios.post("/api/themes/update", { id: theme.id, name: name });
        onUpdate();
    };

    const [loading, setLoading] = React.useState(false);
    const [message, setMessage] = React.useState("");
    const [time, setTime] = React.useState(+new Date());

    const generateBorder = () => {
        let now = new Date();
        const _messages = [] as string[];
        setLoading(true);
        setMessage("Starting generation...");
        if (!eventSource) {
            eventSource = new EventSource("/api/themes/generateBorder?id=" + theme.id, { withCredentials: true });

            eventSource.onmessage = (event) => {
                console.log(event.data);

                if (event.data.indexOf("border") == 0) {
                    setMessage("Generating Border Image");
                }

                if (event.data.indexOf("done") == 0) {
                    setMessage("Finished in " + (new Date().getTime() - now.getTime()) / 1000 + "s");

                    eventSource.close();
                    eventSource = null;
                    setTime(+new Date());
                    onUpdate();
                    setLoading(false);
                }
            };
        }
    };

    const generateImage = () => {
        let now = new Date();
        const _messages = [] as string[];
        setLoading(true);
        setMessage("Starting generation...");
        if (!eventSource) {
            eventSource = new EventSource("/api/themes/generateImage?id=" + theme.id, { withCredentials: true });

            eventSource.onmessage = (event) => {
                console.log(event.data);

                if (event.data.indexOf("image") == 0) {
                    setMessage("Generating Theme Image");
                }

                if (event.data.indexOf("done") == 0) {
                    setMessage("Finished in " + (new Date().getTime() - now.getTime()) / 1000 + "s");

                    eventSource.close();
                    eventSource = null;
                    setTime(+new Date());
                    onUpdate();
                    setLoading(false);
                }
            };
        }
    };

    const makeTransparent = () => {
        axios.get("/api/themes/makeTransparent", { params: { id: theme.id } }).then((response) => {
            setTime(+new Date());
            onUpdate();
        });
    };

    const [showModal, setShowModal] = React.useState(false);

    return (
        <>
            {theme.id && (
                <Box width="220px" height={"450px"} onClick={() => setShowModal(true)}>
                    {/* <FormField label="Name">
                        <TextInput value={name} onChange={(e) => setName(e.target.value)} onBlur={update} />
                    </FormField> */}
                    <Stack>
                        {theme.themeImageID && <Image src={"/api/images/" + theme.themeImageID} width="220px"></Image>}
                        {theme.borderImageID && <Image src={"/api/images/" + theme.borderImageID} width="220px"></Image>}
                        {!theme.borderImageID && <Image src={"/images/blank-border.png"} width="220px"></Image>}
                        <Box margin={{ top: "300px" }} background={{ color: "background", opacity: 0.8 }}>
                            <Text textAlign="center" wordBreak="break-word">
                                {name}
                            </Text>
                        </Box>
                    </Stack>
                    {!loading && <></>}
                    {loading && <Text>{message}</Text>}
                </Box>
            )}
            {!theme.id && <Text>{theme.name}</Text>}
            <StyledModal isOpen={showModal} setIsOpen={setShowModal}>
                <Box width={"medium"} gap="small">
                    {!loading && (
                        <Box gap="small">
                            <Button label="Create Image" onClick={generateImage}></Button>
                            <Button label="Create Border" onClick={generateBorder}></Button>
                            <Button label="Make Border Transparent" onClick={makeTransparent}></Button>
                        </Box>
                    )}
                    {(loading || message) && <Text>{message}</Text>}
                </Box>
            </StyledModal>
        </>
    );
};

export default ThemeViewOld;
